<div class="site-page-header-ghost-wrapper">
  <nz-page-header [nzGhost]="false">
    <nz-page-header-title>
      <span class="me-3" *ngIf="form?.canGoBack()" (click)="goBackForm()"><i class="fa-solid fa-arrow-left"></i></span>
      <span>{{showTitle ? form?.title : ''}}</span>
    </nz-page-header-title>
    <!-- <nz-page-header-subtitle>This is a subtitle</nz-page-header-subtitle> -->

    <!-- Tags  -->
    <!-- <nz-page-header-tags>
      <nz-tag [nzColor]="'blue'">{{form.state}}</nz-tag>
    </nz-page-header-tags> -->

    <!-- Acciones -->
    <nz-page-header-extra>
      <ng-container *ngFor="let item of form?.visibleHeaderActions | slice:0:3">
        <!-- *ngIf="item._visible && item.location === 'HEADER' -->
        <span class="btnContainer">
          <button nz-button nzType="primary" *ngIf="item.visible" [disabled]="item?.disabled || form?.busy"
            (click)="form.startAction(item.actionCode)">
            {{item.actionName}}
          </button>
        </span>
      </ng-container>

      <ng-container *ngIf="form?.visibleHeaderActions?.length === 4">
        <ng-container *ngFor="let item of form?.visibleHeaderActions | slice:3:1">
          <span class="btnContainer">
            <button nz-button nzType="primary" *ngIf="item.visible" [disabled]="item?.disabled || form?.busy"
              (click)="form.startAction(item.actionCode)">
              {{item.actionName}}
            </button>
          </span>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="form?.visibleHeaderActions?.length > 4">
        <span class="btnContainer">
          <button nz-button nzNoAnimation nz-dropdown [nzDropdownMenu]="menu" style="border: none; padding: 0">
            <i class="{{ellipsisIcon}}" nzTheme="outline" style="font-size: 20px; vertical-align: top;"></i>
          </button>
        </span>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <ng-container *ngFor="let item of form?.visibleHeaderActions | slice:3">
              <li nz-menu-item *ngIf="item.visible" [nzDisabled]="item?.disabled"
                (click)="form.startAction(item.actionCode)">
                {{item.actionName}}
              </li>
            </ng-container>
          </ul>
        </nz-dropdown-menu>
      </ng-container>

    </nz-page-header-extra>
  </nz-page-header>
</div>
